module.exports = __webpack_public_path__ + "img/123ne.e85dc5cf.svg";